import axios from "axios";
import { getFileHeaders, getHeaders } from "../utils/main";
import endpoints from "./endpoints";


export const CreatefilefirebaseCreateurlApi = async (blobUrl) => {
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  const formData = new FormData();
  formData.append("audioBlob", blob, "merged_audio.mp3");

  const callResponse = await axios({
    url: endpoints.filefirebaseCreateurl,
    method: "post",
    headers: getFileHeaders(),
    data: formData,
  })
    .then((response) => response.data)
    .catch((err) => ({ status: 0, response: err.response, code: err.response.status }));

  return callResponse;
};
